var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reg-container -scrollable text"},[_vm._v(" 登记表单 "),_c('sea-button',{staticClass:"custombtn",on:{"action":_vm.joinRoom}},[_vm._v("进入视频处理")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }